import React ,{useEffect} from "react";
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {useAuthContext} from '../hooks/useAuthContext';
import {Helmet} from "react-helmet";
import { useLogout } from "../hooks/useLogout";

export default function ProductUpdate(){

    const navigate = useNavigate("/")
    const {user,dispatch} = useAuthContext()
    const{logout} = useLogout();
    useEffect(() => {
      const users = Cookies.get('token')

      if(!users ){
        logout()
      }

try{
        const User = jwtDecode(users)
        const checkToken = async() =>{
          const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
        
        if(!isExpired){
                        
        }else{
          
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
            method: 'GET',
            headers: {'Content-Type':'application/json',
        },
        credentials:'include'
        })
     
      if(response.status === 200){

         const json = await response.json()
         dispatch({ type: 'LOGIN', payload: json.token })
         navigate("/")
      }else{
 
        logout()
      }
        }
      
      }
        
      
      
      checkToken()
    }catch(e){

      if(e.message.includes("Invalid token specified")){
        logout()
      }
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

    if(user){
    
    return(
        <div className=" text-black min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mx-auto ">
          <Helmet>
                <meta charSet="utf-8" />
                <title>Product Updates - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
        <h1 className="dark:text-white font-Rajdhani bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Product Updates</h1>
       <p className="font-Rajdhani text-xl font-normal dark:text-white">This page will provide you information on latest product updates and how to use flash in general with videos</p>
       <div className="font-Rajdhani font-normal dark:text-white">
        {/* Form Builder v2 — Featured Update */}
        <div className="mb-6 border dark:border-gray-700 rounded-xl overflow-hidden">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-5 py-3 flex items-center gap-2">
            <span className="bg-white text-indigo-600 text-xs font-bold px-2 py-0.5 rounded-full">NEW</span>
            <h4 className="text-white font-semibold m-0">AI Form Builder</h4>
          </div>
          <div className="p-5 dark:bg-[#23263a]">
            <p className="text-gray-600 dark:text-gray-300 font-medium mb-3">
              Build beautiful, AI-powered forms in seconds. Describe what you need and our AI generates a fully functional form with smart fields, validation, and themes.
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mb-4">
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">AI-generated forms from a simple description</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">3 built-in themes (Default, Dark, Colorful)</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">Advanced design customization (15+ style options)</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">reCAPTCHA spam protection</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">Email notifications on new responses</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">Embeddable forms & shareable links</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">Custom domains & branding removal (Pro+)</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">&#10003;</span>
                <span className="text-sm">Success message placement (fullpage, inline, modal)</span>
              </div>
            </div>
            <a
              href="/form-builder"
              className="inline-block px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold no-underline"
            >
              Try Form Builder
            </a>
          </div>
        </div>

        <h4>Previous Updates:</h4>
        <ul>
          <li>Enhanced UI - Added Icons</li>
          <li>AI Text-to-Speech added</li>
          <li>History page now allows you to edit your content and history page has become more organised</li>
          <li>Create Custom Flash! - New Create custom flashes for your use case. watch video below!</li>
        </ul>
       </div>
        <div className="grid md:grid-cols-2 pt-10">

            <div>
<h2 className="font-Rajdhani text-xl font-medium dark:text-white pb-2">What is Content Flash AI?</h2>
{/* <iframe className="w-3/4 rounded" src="https://www.youtube.com/embed/xKd4cZvm6cs?si=altuTV82UdBfPFlN" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
<iframe className="w-3/4 rounded"src="https://www.youtube.com/embed/cviuDpVU7zU?si=vG1T6igURhiB52Pz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
             <div>
            <h2 className="font-Rajdhani text-xl font-medium pb-2 dark:text-white">How to generate AI images using flash?</h2>
              {/* <iframe className="w-3/4 rounded" src="https://www.youtube.com/embed/0lOHbZf-Miw?si=KG5rkuFu8RDaCHD4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              <iframe className="w-3/4 rounded"src="https://www.youtube.com/embed/IdOIV5CJZBI?si=qZaGs6zdeeEgyAY8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div> 

            <div className="pt-3">
              <h2 className="font-Rajdhani text-xl font-medium pb-2 dark:text-white pt-2">How to generate content using content generation tools?</h2>
              <iframe className="w-3/4 rounded" src="https://www.youtube.com/embed/D7i35X6dpN4?si=KYGwSaLxK3rjk7cw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
   
            </div>

            <div className="pt-3">
              <h2 className="font-Rajdhani text-xl font-medium pb-2 dark:text-white pt-2">Create custom flashes</h2>
              <iframe className="w-3/4 rounded" src="https://www.youtube.com/embed/D7i35X6dpN4?si=KYGwSaLxK3rjk7cw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
   
            </div>

        </div>
        </div>
      
    );
    }else{
      return navigate("/")
    }
}